import { cleanProps } from "../../utils/index.js";
const tdPropsToClean = [
    'textWrap',
    'lineClamp',
    'maxWidth',
    'wordBreak',
    'size',
    'align',
    'contentClassName'
];
const thPropsToClean = [
    'sort',
    "description",
    'interactive',
    'sticky'
];
const trPropsToClean = [
    'striped',
    'highlightOnHover',
    'cellLineClamp',
    'cellMaxWidth',
    'cellSize',
    'cellTextWrap',
    'cellWordBreak',
    'tableBordered',
    'color',
    'isGroupHeader'
];
const tablePropsToClean = [
    ...tdPropsToClean,
    ...thPropsToClean,
    ...trPropsToClean,
    'bordered',
    'scrollable',
    'firstColumnSticky',
    'headerCellInteractive',
    'headerSticky',
    'scrollClassName',
    'loading',
    'maxColumns'
];
const cleanTableProps = (props)=>cleanProps(props, tablePropsToClean);
export { cleanTableProps };
